import { render, staticRenderFns } from "./FaceScanner.vue?vue&type=template&id=0afb6eb6&scoped=true"
import script from "./FaceScanner.vue?vue&type=script&lang=js"
export * from "./FaceScanner.vue?vue&type=script&lang=js"
import style0 from "./FaceScanner.vue?vue&type=style&index=0&id=0afb6eb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afb6eb6",
  null
  
)

export default component.exports